import React from "react";
import formatMetric from "../util/formatMetric";
const InputThroughput = ({ metrics }) => {
  const {
    rate: { one_minute: oneMinute, five_minute: fiveMinute, fifteen_minute: fifteenMinute }
  } = metrics;
  return /* @__PURE__ */ React.createElement("div", { className: "graylog-input-metrics" }, /* @__PURE__ */ React.createElement("h3", null, "Throughput / Metrics"), /* @__PURE__ */ React.createElement("span", null, !Number.isNaN(oneMinute) && `1 minute average rate: ${formatMetric(oneMinute)} msg/s`, /* @__PURE__ */ React.createElement("br", null), !Number.isNaN(fiveMinute) && `5 minute average rate: ${formatMetric(fiveMinute)} msg/s`, /* @__PURE__ */ React.createElement("br", null), !Number.isNaN(fifteenMinute) && `15 minute average rate: ${formatMetric(fifteenMinute)} msg/s`));
};
export default InputThroughput;
